import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import ClubListItem from 'app/components/club/ClubListItem';
import AddIcon from '@material-ui/icons/Add';

export default function ClubSelect(props) {
    const { onClose, open, currentClubId, clubs } = props;

    const handleClose = () => {
        onClose();
    };

    const handleListItemClick = value => {
        if (value === 'newClub') window.location = process.env.MIX_HOME_BASEURL + '/register/club';
        else if (value.id == currentClubId) onClose();
        else window.location = value.url;
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="club-select-dialog-title"
            open={open}
            fullWidth
            maxWidth='sm'
            >
            <DialogTitle id="club-select-dialog-title">Select your Active Club</DialogTitle>
            <List>
                {clubs.map(club => (
                    <ClubListItem
                        key={club.id}
                        club={club}
                        divider={true}
                        button
                        onClick={() => handleListItemClick(club)}
                        selected={(currentClubId == club.id)}
                    />
                ))}
                <ListItem button onClick={() => handleListItemClick('newClub')}>
                    <ListItemAvatar>
                        <Avatar>
                            <AddIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Create or Find a Club" />
                </ListItem>
            </List>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}
